<script>
    import "firebase/firestore";
    import { userStore } from '../stores';

    import { getContext } from 'svelte';

    import FooterLink from './FooterLink.svelte';

    const db = getContext('firebase').getFirebase().firestore();

    let links = [];
    let orgId;
    let adding = false;
    let newText = '';
    let newRef = '';

    userStore.subscribe((a) => {
        if (a === null || a.organizationID === null) {
            return;
        }
        orgId = a.organizationID;
        db.collection('organizations').doc(`${a.organizationID}`).get().then((doc) => {
            if (doc.exists && doc.data().footerItems) {
                links = doc.data().footerItems.filter(a => a.type === 'LINK');
            }
        }).catch((e) => {
            console.log('Error: ', e);
        });
    });

    function refreshQuery() {
        db.collection('organizations').doc(`${orgId}`).get().then((doc) => {
            if (doc.exists && doc.data().footerItems) {
                links = doc.data().footerItems.filter(a => a.type === 'LINK');
            }
        }).catch((e) => {
            console.log('Error: ', e);
        });
    }

    function updateLink(event) {
        if (!event || !event.detail || !event.detail.oldText || !event.detail.text || !event.detail.oldRef || !event.detail.ref) {
            return;
        }
        const a = links;
        for (let i = 0; i < links.length; i++) {
            if (links[i].text === event.detail.oldText && links[i].ref === event.detail.oldRef) {
                a[i].text = event.detail.text;
                a[i].ref = event.detail.ref;
            }
        }
        if (!orgId) {
            return;
        }
        db.collection('organizations').doc(`${orgId}`).set({footerItems: a}, { merge: true });
    }

    async function deleteLink(event) {
        if (!event || !event.detail || !event.detail.text || !event.detail.ref) {
            return;
        }
        const a = [];
        for (let i = 0; i < links.length; i++) {
            if (links[i].text === event.detail.text && links[i].ref === event.detail.ref) {
                continue;
            }
            a.push(links[i]);
        }
        if (!orgId) {
            return;
        }
        await db.collection('organizations').doc(`${orgId}`).set({footerItems: a}, { merge: true });
        refreshQuery();
    }

    function onPlusClicked() {
        adding = !adding;
        newText = '';
        newRef = '';
    }

    async function onCheckClicked() {
        if (!newText || !newRef || !orgId) {
            return;
        }
        const a = links;
        a.push({
            type: 'LINK',
            text: newText,
            ref: newRef
        })
        adding = !adding;
        newText = '';
        newRef = '';
        await db.collection('organizations').doc(`${orgId}`).set({footerItems: a}, { merge: true });
        refreshQuery();
    }

    function onTimesClicked() {
        adding = !adding;
        newText = '';
        newRef = '';
    }
</script>

<div class="wrapper">
    {#each links as link}
        <FooterLink {link} on:updateLink={updateLink} on:deleteLink={deleteLink} />
    {/each}
    {#if !adding}
        <div on:click={onPlusClicked} class="plus-circle">
            <i a="plus" class="fas fa-plus"></i>
        </div>
    {:else}
        <div class="plus-wrapper">
            <div class="plus-row">
                <input bind:value={newText} type="text" placeholder='Text'>
                <div class="plus-icon-button">
                    <i on:click={onCheckClicked} class="fas fa-check"></i>
                </div>
            </div>
            <div class="plus-row">
                <input bind:value={newRef} type="text" placeholder='https://'>
                <div class="plus-icon-button">
                    <i on:click={onTimesClicked} class="fas fa-times"></i>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .wrapper {
        color: black;
    }

    .plus-circle {
        background-color: var(--primary);
        width: 50px;
        height: 50px;
        border-radius: 25px;
        text-align: center;
        color: white;
        margin: auto;
        box-shadow: var(--box-shadow);
    }

    .plus-circle:hover {
        cursor: pointer;
    }

    .plus-circle i {
        margin-top: 12px;
        font-size: 24px;
    }

    .plus-wrapper {
        background-color: var(--primary);
        border-radius: 10px;
        padding: 10px;
    }

    .plus-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
    }

    .plus-wrapper input {
        margin: 5px;
    }

    .plus-icon-button {
        display: inline-block;
        color: white;
        margin-left: 10px;
        padding: 10px;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        -webkit-transition: all 0.25s;
        transition: all 0.25s;
    }

    .plus-icon-button:hover {
        cursor: pointer;
        color: var(--primary);
        background-color: white;
        box-shadow: var(--box-shadow);
    }

    .plus-icon-button i {
        margin-top: 2px;
        font-size: 24px;
    }
</style>
